import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = () => {
  const { isAuthenticated, isAdmin, loading } = useContext(AuthContext);
  console.log('PrivateRoute - isAuthenticated:', isAuthenticated, 'isAdmin:', isAdmin, 'loading:', loading);

  if (loading) {
    return <div>Loading...</div>; // Or a spinner
  }

  if (!isAuthenticated) {
    console.log('PrivateRoute: Not authenticated, navigating to login.');
    return <Navigate to="/admin/login" />;
  }

  // For routes that require admin access, check isAdmin
  // This assumes all routes within this PrivateRoute require admin access.
  // If some protected routes are for regular users, this logic needs to be more granular.
  if (!isAdmin) {
    console.log('PrivateRoute: Authenticated but not admin, navigating to dashboard.');
    return <Navigate to="/" />; // Redirect non-admins to dashboard
  }

  console.log('PrivateRoute: Authenticated and admin, rendering children.');
  return <Outlet />;
};

export default PrivateRoute;